// extracted by mini-css-extract-plugin
export var label = "_9u-1";
export var reminder = "_9u-0";